import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=7e1c50bc&scoped=true&lang=pug&"
import script from "./ComparisonCard.vue?vue&type=script&lang=js&"
export * from "./ComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=7e1c50bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c50bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VOverlay,VSkeletonLoader,VTooltip})
